// tslint:disable
import {get} from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import {InputField} from '../../components/fields/input.field';
import {ConsoleLib} from '../../components/libs/console.lib';
import {ListResourceLoader} from '../../components/libs/list-resource-loader';
import {ListLib} from '../../components/libs/list.lib';
import {ListConsole} from '../../components/structurals/list-console';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {Pagination} from '../../components/structurals/pagination';
import {IriPresenter} from '../../components/structurals/presenters/iri-presenter';
import {
    ListActions,
    ListResponsePresenterTable
} from '../../components/structurals/presenters/list-response-presenter-table';
import {Notification} from '../../index';
import {SelectField} from "../../components/fields/select.field";

export class AtasEnquiryList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch();
    }

    public statuses = [
        'New',
        'Closed',
        'In Progress',
        'Not interested',
        'Follow up'
    ];


    render() {
        return (
            <ListResourceLoader forceQuery={{'order[processed]': 'ASC', 'order[createdAt]': 'DESC'}} entity="enquiry" render={(list: ListLib) => <div>
                <div id="page-title">
                    <h2>
                        Enquiry
                    </h2>
                    <p>Lorem</p>
                </div>

                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>

                        <SelectField
                            field={console.setQuery('processed', {title: 'Processed'})}
                            options={[
                                {value: 0, label: 'New'},
                                {value: 1, label: 'Closed'},
                                {value: 2, label: 'In Progress'},
                                {value: 3, label: 'Not interested'},
                                {value: 4, label: 'Follow up'},
                            ]}
                        />
                        {/*<CheckboxField field={console.setQuery('processed', {title: 'Processed'})}/>*/}
                        {/*<CheckboxField field={console.setQuery('processed', {title: 'Not Processed'}, (value: any) => !value)}/>*/}

                        <InputField field={console.setQuery('name', {title: 'Search in names', placeholder: 'some keyword'})}/>
                        <InputField field={console.setQuery('email', {title: 'Search in emails', placeholder: 'some keyword'})}/>
                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Company</th>
                                    <th>E-mail</th>
                                    <th>Processed</th>
                                    <th>Created At</th>
                                    <th></th>
                                </tr>
                            );
                        }}

                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>
                                        <IriPresenter iri={get(item, 'title[@id]')} render={(title: any) => get(title, 'name')}/> {get(item, 'name', '-')}
                                    </td>
                                    <td>{get(item, 'company', '-')}</td>
                                    <td>{get(item, 'email', '-')}</td>
                                    <td>
                                        {this.statuses[get(item, 'processed')]}
                                    </td>
                                    <td>
                                        {moment(get(item, 'createdAt')).format('DD/MM/Y H:mm')}
                                    </td>
                                    <td>
                                        <div className="btn-group btn-group-sm btn-group-xs">
                                            <button className="btn btn-xs btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View enquiry</button>
                                            <button type="button" className="btn btn-xs btn-primary dropdown-toggle" data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <ul className="dropdown-menu" role="menu">
                                                <li>
                                                    <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                                    Delete enquire
                                                </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>

                </div>


            </div>}
            />
        );
    }

    private async handleDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        const answer = await Notification.delete();

        if (answer === true) {
            try {
                list.isLoading$.next(true);
                await ListActions.delete(item['@id']);
            } catch (error) {

            } finally {
                list.isLoading$.next(false);
                list.refetch();
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/atas.enquiry.list.tsx